/* src/app/modules/ct-status/components/cts-gantry-functional-unit-list/cts-gantry-functional-unit-list.component.scss */
:host {
  display: flex;
  flex-flow: column nowrap;
  gap: 0.25rem;
  align-items: start;
}
.unit-label {
  height: 1.75rem;
  align-content: center;
}
.cts-gantry-grid-highlight {
  color: var(--text-primary, rgba(0, 0, 0, 0.9));
}
/*# sourceMappingURL=cts-gantry-functional-unit-list.component.css.map */
